import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "tenant-container"
};
import { ref } from 'vue';
import TenantContent from './components/TenantContent';
import ClinicContent from './components/ClinicContent';
export default {
  __name: 'index',
  setup(__props) {
    const activeName = ref('租户信息');
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          type: "card",
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "租户信息",
            name: "租户信息"
          }, {
            default: _withCtx(() => [_createVNode(_unref(TenantContent), {
              activeName: activeName.value
            }, null, 8, ["activeName"])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "门诊信息",
            name: "门诊信息"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ClinicContent), {
              activeName: activeName.value
            }, null, 8, ["activeName"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]);
    };
  }
};